import { getRoot, Instance, types } from 'mobx-state-tree';
import { PageModel, PageRoutes, RootType } from '../../../internal';
import { quizImageStoredPath, quizImageUrl } from '../../../utils/api/QuizApi';

export const PitanjeDetaljiModel = types
  .compose(
    PageModel,
    types.model({
      questionText: types.optional(types.string, ''),
      orderNumber: types.optional(types.number, 0),
      isActive: types.optional(types.boolean, false),
      image: types.optional(types.maybeNull(types.string), null),
    })
  )
  .views((self) => ({
    get root(): RootType {
      return getRoot(self);
    },
    get imageUrl(): string {
      return quizImageUrl(self.image);
    },
  }))
  .actions((self) => ({
    setQuestionText(value: string) {
      self.questionText = value;
    },
    setOrderNumber(value: number) {
      self.orderNumber = value;
    },
    setIsActive(value: boolean) {
      self.isActive = value;
    },
    removeImage() {
      self.image = null;
    },
    setImage(value: string | null) {
      self.image = value;
    },
    async uploadImage(file: File) {
      const { quizId } = self.root.router.queryParams;
      try {
        const filename = await self.root.api.quiz.uploadQuestionImage(
          Number(quizId),
          file
        );
        this.setImage(quizImageStoredPath(filename));
      } catch (err: any) {
        const message =
          err?.response?.data?.message ??
          'Došlo je do greške pri otpremanju slike.';
        self.root.showFailure(message, null);
      }
    },
    setFromApi(data: {
      questionText: string;
      orderNumber: number;
      isActive: boolean;
      image?: string | null;
    }) {
      self.questionText = data.questionText;
      self.orderNumber = data.orderNumber;
      self.isActive = data.isActive;
      self.image = data.image ?? null;
    },
    navigateBack() {
      const { quizId } = self.root.router.queryParams;
      self.root.router.navigate({
        newView: PageRoutes.Pitanja.id,
        queryParams: { quizId },
      });
    },
    navigateToOdgovori() {
      const { quizId, id } = self.root.router.queryParams;
      self.root.router.navigate({
        newView: PageRoutes.Odgovori.id,
        queryParams: { quizId, questionId: id },
      });
    },
    async beforePageEnter() {
      const { quizId, id } = self.root.router.queryParams;
      const question = await self.root.api.quiz.getQuestion(
        Number(quizId),
        Number(id)
      );
      this.setFromApi(question);
    },
    async submit() {
      const { quizId, id } = self.root.router.queryParams;
      try {
        await self.root.api.quiz.updateQuestion(Number(quizId), Number(id), {
          questionText: self.questionText,
          orderNumber: self.orderNumber,
          isActive: self.isActive,
          image: self.image,
        });
        this.navigateBack();
      } catch (err: any) {
        const message =
          err?.response?.data?.message ??
          'Došlo je do greške pri čuvanju pitanja.';
        self.root.showFailure(message, null);
      }
    },
  }))
  .named('PitanjeDetaljiModel');

export type PitanjeDetaljiModelType = Instance<typeof PitanjeDetaljiModel>;
